import api from "./api"

export const getStores = async () => {
  const response = await api.get("/stores")
  return response.data
}

export const getActiveStores = async () => {
  const response = await api.get("/stores/active")
  return response.data
}

export const getStoreFormData = async () => {
  const response = await api.get("/stores/form-data")
  return response.data
}

export const getStoreById = async (storeId) => {
  const response = await api.get(`/stores/${storeId}`)
  return response.data
}

export const getNextStoreCode = async (params = {}) => {
  const response = await api.get("/stores/next-code", { params })
  return response.data
}

export const createStore = async (storeData) => {
  const response = await api.post("/stores", storeData)
  return response.data
}

export const updateStore = async (storeId, storeData) => {
  const response = await api.put(`/stores/${storeId}`, storeData)
  return response.data
}

export const deleteStore = async (storeId) => {
  const response = await api.delete(`/stores/${storeId}`)
  return response.data
}